module.exports = __webpack_public_path__ + "img/voltaje_c.3bc0b12e.svg";